import React, { useState } from "react";
import { Box, Link, Typography } from "@material-ui/core";
import { ScanSettings, Barcode } from "scandit-sdk";
import {
  IntroText,
  BarcodeScanner,
  PatientDetailsRegisterForm,
  FormActionDrawer
} from "../../../components";
import { useConsumerAuth } from "../../../hooks";
import { formatDate } from "../../../utils";
import { useTranslation } from "react-i18next";

const parsePdf417Data = data => {
  const lines = data.split("\n");

  return lines
    .map(line => {
      const identifier = line.substring(0, 3);
      const value = line.substring(3);

      if (identifier === "DAC") {
        return { first_name: value };
      } else if (identifier === "DCS") {
        return { last_name: value };
      } else if (identifier === "DBB") {
        return { dob: formatDate(value, "MMDDYYYY", "YYYY-MM-DD") };
      }
    })
    .reduce((prev, cur) => ({ ...prev, ...cur }));
};

const VaxYesRegisterStepIdScan = ({
  registerData = {},
  setDrawerClearance,
  onNext = () => {}
}) => {
  const { t } = useTranslation();

  const { first_name, last_name, dob } = useConsumerAuth();
  const [idScan, setIdScan] = useState(() =>
    registerData.idScan ? registerData.idScan : undefined
  );

  const handleScanPatientId = scan => {
    if (!scan || !Array.isArray(scan.barcodes)) return;

    const [barcode] = scan.barcodes;

    if (barcode && barcode.data) {
      const finalData = parsePdf417Data(barcode.data);

      setIdScan(finalData);
    }
  };

  return (
    <>
      {idScan ? (
        <>
          <IntroText>
            {t("vax_yes.vax_yes_register_id_scan.intro_text")}
          </IntroText>
          <Box textAlign="center" mb={2}>
            <Typography>
              {t("vax_yes.vax_yes_register_id_scan.skip_text")}{" "}
              <Link onClick={() => setIdScan({})} component="button">
                {t("vax_yes.vax_yes_register_id_scan.button_skip")}
              </Link>
            </Typography>
          </Box>

          <BarcodeScanner
            onScan={scan => handleScanPatientId(scan)}
            settings={
              new ScanSettings({
                enabledSymbologies: [Barcode.Symbology.PDF417]
              })
            }
          />
        </>
      ) : (
        <>
          <IntroText>
            {t("vax_yes.vax_yes_register_id_scan.verify_intro_text")}
          </IntroText>
          <PatientDetailsRegisterForm
            initialValues={{
              first_name,
              last_name,
              dob,
              ...idScan,
              ...registerData
            }}
            onSubmitSuccess={data =>
              onNext({ ...data, pristine: { ...idScan } })
            }
          >
            <FormActionDrawer
              setDrawerClearance={setDrawerClearance}
              nextButtonLabel={t(
                "vax_yes.vax_yes_register_id_scan.button_next"
              )}
            />
          </PatientDetailsRegisterForm>
          {/* <Box mt={1} textAlign="center">
            <Link onClick={() => setIdScan()} component="button">
              {t("vax_yes.vax_yes_register_id_scan.button_scan")}
            </Link>
          </Box> */}
        </>
      )}
    </>
  );
};

export { VaxYesRegisterStepIdScan };
